<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
        <span v-html="deviceNameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="deviceCode" size="small" style="width: 280px" />
        <span v-html="deviceCodeVer"></span>
      </div>

      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">设备类型：</span>-->
        <!--</div>-->
        <!--<el-select v-model="deviceType" size="small" style="width: 280px">-->
          <!--<el-option v-for="item in deviceTypeList" :key="item.code"-->
                     <!--:label="item.name" :value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂家：</span>
        </div>
        <el-select v-model="deviceManufacturer" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="deviceModelName" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">梯控计划：</span>
        </div>
        <el-select v-model="planCode" size="small" style="width: 280px">
          <el-option v-for="item in planList" :key="item.code"
                     :label="item.planName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="location" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">所在楼栋：</span>
        </div>
        <el-select v-model="formData.buildingCode" size="small" style="width: 280px">
          <el-option v-for="item in buildingList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePersonCode" size="small" style="width: 280px" multiple @change="responsiblePersonChange" filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="请输入关键字搜索">
          <el-option v-for="item in responsiblePersonList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
        <span v-html="responsiblePersonVer"></span>
      </div>

      <!--<div class="form-line" v-if="hasResponsiblePerson">-->
        <!--<div class="textBox">-->
          <!--<b class="red"></b>-->
          <!--<span class="line-text">责任人：</span>-->
        <!--</div>-->
        <!--<el-select v-model="responsiblePerson"-->
                   <!--filterable-->
                   <!--remote-->
                   <!--reserve-keyword-->
                   <!--size="small" style="width: 280px"-->
                   <!--:remote-method="remoteMethod"-->
                   <!--placeholder="请输入关键词查询">-->
          <!--<el-option v-for="item in responsiblePersonList" :key="item._value"-->
                     <!--:label="item._label" :value="item._value">-->
          <!--</el-option>-->
        <!--</el-select>-->

      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import InputTree from "../../../components/common/inputs/input-tree";
import { pattern } from "../../../utils/regular";
import { api } from "../../api/LadderControl";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
// let a = document.getElementsByClassName()

export default {
  components: {
    ButtonConfirmNext,
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: "add-device",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧梯控",
            name: "ladder-device"
          },
          {
            value: "设备管理"
          }
        ]
      },
      mainTitle: "添加梯控设备",
      subheading: "",
      deviceName: "",
      deviceNameVer: "<span>不超过32个字</span>",
      deviceCode: "",
      deviceCodeVer: "<span>填写梯控设备序列号，与设备保持一致且唯一</span>",
      deviceType: "8",
      deviceTypeList: [{ code: "8", name: "梯控网关" }],
      deviceManufacturer: "",
      deviceManufacturerList: [],
      deviceModelName: "",
      deviceModelNameList: [],

      planCode: "",
      planName: "",
      planList: [],

      enterpriseCode: "",
      enterpriseName: "",
      enterpriseList: [],

      responsiblePerson: "",
      responsiblePersonCode: "",
      responsiblePersonList: [],
      responsiblePersonVer: "<span>责任人可接受设备离线通知</span>",
      hasParent: false,
      hasResponsiblePerson: true,

      deviceNameHttp: false,
      deviceCodeHttp: false,
      location: '',
      buildingList:[],
      formData:{
        buildingCode:"",
        location:""
    },
    };
  },
  created() {
    this.getAllDeviceManufacture();
    // this.getResponsiblePersonList()
    this.getLiftPlanList();
    this.remoteMethod();
    this.getBuildingList()
  },
  methods: {
    // 获取楼栋列表
    getBuildingList () {
      api.getBuildingList({}).then(data=>{
        this.buildingList = data
      }).catch(errorHandler('获取楼栋列表失败'))
    },
    // 获取梯控计划
    getLiftPlanList() {
      api
        .getLiftPlanList({})
        .then(data => {
          this.planList = data;
        })
        .catch(errorHandler("获取梯控计划失败"));
    },

    getAllDeviceManufacture() {
      api
        .getAllDeviceManufacture({
          moduleCode: "3"
          // deviceType: this.deviceType
        })
        .then(data => {
          this.deviceManufacturerList = data;
          if (this.deviceManufacturerList.length > 0) {
            this.deviceManufacturer = data[0].code;
            this.getAllDeviceType();
          }
        })
        .catch(errorHandler("获取设备厂家失败"));
    },
    getAllDeviceType() {
      api
        .getAllDeviceType({
          moduleCode: "3",
          deviceManufactureCode: this.deviceManufacturer
        })
        .then(data => {
          this.deviceModelNameList = data;
          if (this.deviceModelNameList.length > 0) {
            this.deviceModelName = data[0].code;
          }
        })
        .catch(errorHandler("获取设备型号失败"));
    },

    getResponsiblePersonList(searchKey) {
      api.getResponsiblePerson(searchKey || "").then(list => {
        list.forEach(it => {
          it._value = it.code;
          it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`;
        });
        this.responsiblePersonList = list;
      });
    },
    remoteMethod(query) {
      this.getResponsiblePersonList(query);
    },
    responsiblePersonChange(checkData) {
      if (checkData.length > 3) {
        checkData.length = 3;
        nError("责任人最多选3个");
      }
    },
    addNext() {
      if (!this.deviceName) {
        this.deviceNameVer = '<span style="color: red;">请输入设备名称</span>';
        return false;
      }
      if (!this.deviceCode) {
        this.deviceCodeVer = '<span style="color: red;">请输入设备编号</span>';
        return false;
      }
      if (!this.deviceCodeHttp || !this.deviceNameHttp) {
        return false;
      } else {
        this.deviceNameVer = "<span>不超过32个字</span>";
        this.deviceCodeVer =
          "<span>填写梯控设备序列号，与设备保持一致且唯一</span>";
      }
      this.buildingList.map(v => {
        if (v.code === this.formData.buildingCode) {
          this.formData.buildingName = v.name
        }
      })
      let obj = {
        deviceName: this.deviceName,
        deviceCode: this.deviceCode,
        deviceManufacturerCode: this.deviceManufacturer,
        deviceManufacturerName: "",
        deviceModelCode: this.deviceModelName,
        deviceModelName: "",
        responsiblePersonCode: this.responsiblePersonCode.join(","),
        responsiblePersonName: "",
        deviceManufacturer: this.deviceManufacturer,
        deviceType: this.deviceType,
        planCode: this.planCode,
        planName: this.planName,
        location: this.location,
        buildingName:this.formData.buildingName,
        buildingCode:this.formData.buildingCode,
      };
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturer) {
          obj.deviceManufacturerName = v.name;
        }
      });
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelName) {
          obj.deviceModelName = v.name;
        }
      });
      let responsiblePersonNameArr = [];
      this.responsiblePersonList.map(v => {
        let responsiblePersonCodeStr = this.responsiblePersonCode.join(",");
        if (responsiblePersonCodeStr.indexOf(v.code) !== -1) {
          responsiblePersonNameArr.push(v.name);
        }
      });
      obj.responsiblePersonName = responsiblePersonNameArr.join(",");
      api
        .addAccessDevice(obj)
        .then(() => {
          nSuccess("添加成功");
          this.deviceName = "";
          this.deviceCode = "";
          this.responsiblePersonCode = "";
        })
        .catch(errorHandler("添加梯控设备失败"));
    },
    add() {
      if (!this.deviceName) {
        this.deviceNameVer = '<span style="color: red;">请输入设备名称</span>';
        return false;
      }
      if (!this.deviceCode) {
        this.deviceCodeVer = '<span style="color: red;">请输入设备编号</span>';
        return false;
      }
      if (!this.deviceCodeHttp || !this.deviceNameHttp) {
        return false;
      } else {
        this.deviceNameVer = "<span>不超过32个字</span>";
        this.deviceCodeVer =
          "<span>填写梯控设备序列号，与设备保持一致且唯一</span>";
      }
      this.buildingList.map(v => {
        if (v.code === this.formData.buildingCode) {
          this.formData.buildingName = v.name
        }
      })
      let obj = {
        deviceName: this.deviceName,
        deviceCode: this.deviceCode,
        deviceManufacturerCode: this.deviceManufacturer,
        deviceManufacturerName: "",
        deviceModelCode: this.deviceModelName,
        deviceModelName: "",
        responsiblePersonCode: this.responsiblePersonCode.join(","),
        responsiblePersonName: "",
        deviceManufacturer: this.deviceManufacturer,
        deviceType: this.deviceType,
        planCode: this.planCode,
        planName: this.planName,
        buildingName:this.formData.buildingName,
        buildingCode:this.formData.buildingCode,
        location: this.location
      };
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturer) {
          obj.deviceManufacturerName = v.name;
        }
      });
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelName) {
          obj.deviceModelName = v.name;
        }
      });
      let responsiblePersonNameArr = [];
      this.responsiblePersonList.map(v => {
        let responsiblePersonCodeStr = this.responsiblePersonCode.join(",");
        if (responsiblePersonCodeStr.indexOf(v.code) !== -1) {
          responsiblePersonNameArr.push(v.name);
        }
      });
      obj.responsiblePersonName = responsiblePersonNameArr.join(",");
      api
        .addAccessDevice(obj)
        .then(() => {
          nSuccess("添加成功");
          this.strategyCenter();
        })
        .catch(errorHandler("添加梯控设备失败"));
    },
    strategyCenter() {
      this.$router.go(-1);
      // this.$router.push({
      //   path: '/access-control/device/center'
      // })
    }
  },
  watch: {
    deviceType(v) {
      if (this.deviceType === "3" || this.deviceType === "4") {
        this.hasResponsiblePerson = false;
        this.scenceList = [
          { code: "1", name: "公共场景" },
          { code: "2", name: "住户场景" },
          { code: "3", name: "其他场景" }
        ];
      } else {
        this.hasResponsiblePerson = true;
        this.scenceList = [
          { code: "1", name: "公共场景" },
          { code: "2", name: "住户场景" },
          { code: "4", name: "预约场景" },
          { code: "3", name: "其他场景" }
        ];
      }
      this.getAllDeviceManufacture();
    },
    deviceName(v) {
      let ptn = pattern.basicAndCN.test(v);
      if (!ptn) {
        this.deviceNameVer =
          '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>';
        this.deviceNameHttp = false;
      } else {
        this.deviceNameVer = "<span>不超过32个字</span>";
        this.deviceNameHttp = true;
      }
    },
    deviceCode(v) {
      let ptn = pattern.abd123.test(v);
      if (!ptn) {
        this.deviceCodeVer =
          '<span style="color: red;">只允许输入字母，数字</span>';
        this.deviceCodeHttp = false;
      } else {
        this.deviceCodeVer =
          "<span>填写梯控设备序列号，与设备保持一致且唯一</span>";
        this.deviceCodeHttp = true;
      }
    },
    scence(v) {
      if (v === "2") {
        // this.getEnterpriseInfoList()
        // this.getEnterpriseByCode()
      }
    },
    deviceManufacturer(v) {
      if (v === "100080") {
        this.hasParent = true;
      }
      this.getAllDeviceType();
    },
    parentCode() {
      this.parentList.map(v => {
        if (v.deviceCode === this.parentCode) {
          this.parentName = v.deviceName;
        }
      });
    },
    planCode() {
      this.planList.map(v => {
        if (v.code === this.planCode) {
          this.planName = v.planName;
        }
      });
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/LadderDevice/LadderDeviceAdd.vue